import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Card, CardBody, Spinner, Badge, Label } from 'reactstrap'
import moment from 'moment'
import Select from '../../../components/Template/Input/Select'
import DataTable from '../../../components/Template/Table/DataTable'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { getPendingSolicitations } from '../../../store/ducks/humanResources'

class MySolicitations extends Component {
  constructor(props) {
    super(props)
    this.state = {
      subjectsFilter: null,
      statusFilter: [
        {
          value: '0',
          label: 'Em análise',
        },
        {
          value: '2',
          label: 'Recusada',
        },
      ],
    }
  }

  componentDidMount() {
    const { getPendingSolicitations } = this.props

    getPendingSolicitations(false)
  }

  formatAssunto = assunto => {
    switch (assunto) {
      case 'Atestado':
        return 'Ausência'
      case 'Despesa':
        return 'Despesa'
      case 'Férias':
        return 'Férias'
      case 'Retroativo':
        return 'Ponto retroativo'
      default:
        return null
    }
  }

  formatResumo = row => {
    switch (row.pend_assunto) {
      case 'Atestado':
        return `Período: ${moment(row.pend_dt_ini).format('DD/MM')} à ${moment(row.pend_dt_fim).format('DD/MM/YYYY')}`
      case 'Despesa':
        return `${row.mov_desc}`
      case 'Férias':
        return `Período: ${moment(row.pend_dt_ini).format('DD/MM')} à ${moment(row.pend_dt_fim).format('DD/MM/YYYY')}`
      case 'Retroativo':
        return `Período: ${moment(row.pend_dt).format('DD/MM/YYYY')}`
      default:
        return null
    }
  }

  formatStatus = status => {
    switch (status) {
      case '0':
        return <Badge className="badge-soft-info mr-1">Em análise</Badge>
      case '1':
        return <Badge className="badge-soft-success mr-1">Aprovada</Badge>
      case '2':
        return <Badge className="badge-soft-danger mr-1">Recusada</Badge>
      default:
        return null
    }
  }

  render() {
    const {
      getPendingSolicitationsIsLoading, pendingSolicitations,
    } = this.props.humanResources

    const { subjectsFilter, statusFilter } = this.state

    const columns = [
      {
        label: 'ID',
        field: 'pend_id',
        sort: 'disabled',
      },
      {
        label: 'Data de solicitação',
        field: 'pend_dt_sol',
        sort: 'disabled',
      },
      {
        label: 'Assunto',
        field: 'pend_assunto',
        sort: 'disabled',
      },
      {
        label: 'Resumo',
        field: 'resumo',
        sort: 'disabled',
      },
      {
        label: 'Status',
        field: 'status',
        sort: 'disabled',
      },
    ]

    let filteredSolicitations = []
    if (!getPendingSolicitationsIsLoading && pendingSolicitations) {
      // Filter by Status
      if (statusFilter && statusFilter.length > 0) {
        const status = statusFilter.map(i => i.value)
        filteredSolicitations = pendingSolicitations.filter(solicitation => {
          if (solicitation.pend_aprov) {
            return status.some(substring => solicitation.pend_aprov.includes(substring))
          }
          return false
        })
      } else {
        filteredSolicitations = pendingSolicitations
      }

      // Filter by Subject
      if (subjectsFilter && subjectsFilter.length > 0) {
        const subjects = subjectsFilter.map(i => i.value)
        filteredSolicitations = filteredSolicitations.filter(solicitation => {
          if (solicitation.pend_assunto) {
            return subjects.some(substring => solicitation.pend_assunto.includes(substring))
          }
          return false
        })
      }
    }

    return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Solicitações"
            breadcrumbItems={[]}
          />

          <Row>
            <Col className="mb-4" xl={4} lg={4} md={4} sm={4}>
              <Label>
                Filtrar por Status
              </Label>
              <Select
                isMulti
                placeholder="Status"
                defaultValue={[
                  {
                    value: '0',
                    label: 'Em análise',
                  },
                  {
                    value: '2',
                    label: 'Recusada',
                  },
                ]}
                options={[
                  {
                    value: '0',
                    label: 'Em análise',
                  },
                  {
                    value: '1',
                    label: 'Aprovada',
                  },
                  {
                    value: '2',
                    label: 'Recusada',
                  },
                ]}
                onChange={status => this.setState({ statusFilter: status })}
              />
            </Col>

            <Col className="mb-4" xl={4} lg={4} md={4} sm={4}>
              <Label>
                Filtrar por Assunto
              </Label>
              <Select
                isMulti
                placeholder="Assunto"
                options={[
                  {
                    value: 'Atestado',
                    label: 'Atestado',
                  },
                  {
                    value: 'Despesa',
                    label: 'Despesa',
                  },
                  {
                    value: 'Férias',
                    label: 'Férias',
                  },
                  {
                    value: 'Retroativo',
                    label: 'Retroativo',
                  },
                ]}
                onChange={subjects => this.setState({ subjectsFilter: subjects })}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Card>
                <CardBody>
                  {getPendingSolicitationsIsLoading && (
                    <Row>
                      <Col className="d-flex align-items-center justify-content-center py-3">
                        <Spinner />
                      </Col>
                    </Row>
                  )}

                  {!getPendingSolicitationsIsLoading && filteredSolicitations && (
                    <DataTable
                      data={{
                        columns,
                        rows: filteredSolicitations.map(row => ({
                          ...row,
                          pend_dt_sol: moment(row.pend_dt_sol).calendar(),
                          pend_id: (
                            <Link
                              to={{
                                pathname: `/colaborador/solicitacoes/${row.pend_id}`,
                                state: {
                                  solicitation: row,
                                },
                              }}
                            >
                              {row.pend_id}
                            </Link>
                          ),
                          pend_assunto: (
                            <Link
                              to={{
                                pathname: `/colaborador/solicitacoes/${row.pend_id}`,
                                state: {
                                  solicitation: row,
                                },
                              }}
                            >
                              {/* {this.formatAssunto(row.pend_assunto)} */}
                              {row.pend_assunto}
                            </Link>
                          ),
                          resumo: this.formatResumo(row),
                          status: this.formatStatus(row.pend_aprov),
                        })),
                      }}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = state => ({ humanResources: state.humanResources })
const mapDispatchToProps = dispatch => bindActionCreators({ getPendingSolicitations }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(MySolicitations)
